import React, { useState, useContext, useEffect } from 'react';
import TabularDataWidget from '@components/widgets/tabular-data';
import AppDataContext from "@stores/app-data-context";
import { LinkButtonPrimaryBorder } from '@components/ui/buttons';

const LoanMatchesLoader = ({ data }) => {
    const { tables, initialLoadCount, buttonText, loanApproval } = data;
    const [numberOfItems, setNumberOfItems] = useState(initialLoadCount);
    
    const appDataCxt = useContext(AppDataContext);

    const showButton = () => {
        return tables.length > numberOfItems
    }

    useEffect(() => {

        const sessionLoanRequirements = appDataCxt.getLoanRequirements();
        const { vehicleNetworkId } = loanApproval?.extra;

        if (appDataCxt.isLoanTypeStepCompleted !== true
            || (appDataCxt.approvalId !== loanApproval.id)
            || sessionLoanRequirements?.stockId !== vehicleNetworkId) {
            const { loan, user, extra, loanTypeDetails, uiCacheKey } = loanApproval;


            // Loan Type            
            const loanTypeData = (loanTypeDetails.loanType !== "personal"
                ?
                {
                    isLoanTypeStepCompleted: true,
                    loanTypeData: {
                        abnRegistered: loanTypeDetails.abnRegistered,
                        businessRegisteredForGst: loanTypeDetails.businessRegisteredForGst,
                        loanType: loanTypeDetails.loanType,
                        noOfYearsBusinessOperating: loanTypeDetails.noOfYearsBusinessOperating
                    }
                }
                :
                {
                    isLoanTypeStepCompleted: true,
                    loanTypeData: {
                        abnRegistered: "false",
                        businessRegisteredForGst: "false",
                        loanType: loanTypeDetails.loanType,
                        noOfYearsBusinessOperating: null
                    }
                });
                        

            // Employment details
            var employmentData = {
                isEmploymentDetailsStepCompleted: false,
                employmentDetailsData: {
                    currentEmployment: {},
                    previousEmployment: {},
                    employmentIndustryContinuation: false
                }
            }

            const employmentContinuation = (
                user.employmentIndustryContinuation === undefined || user.employmentIndustryContinuation === null
                    ? false
                    : user.employmentIndustryContinuation)

            if (loanTypeDetails.loanType == "personal") {
                var curEmp = user.employment[0];
                const currentEmployment = {
                    employmentType: curEmp.type,
                    months: curEmp.durationMonths,
                    years: curEmp.durationYears,
                };

                var prevEmp = user.employment.length > 1
                    ? user.employment[1]
                    : null;

                var previousEmployment = prevEmp === null
                    ? null
                    : { employmentType: prevEmp.type, months: prevEmp.durationMonths, years: prevEmp.durationYears };

                employmentData = {
                    isEmploymentDetailsStepCompleted: true,
                    employmentDetailsData: {
                        currentEmployment: currentEmployment,
                        previousEmployment: previousEmployment,
                        employmentIndustryContinuation: employmentContinuation
                    }
                }
            }
            
                        
            // Living situation
            const currentAddress = {
                postcode: user.address.postCode,
                state: user.address.state,
                streetName: user.address.street,
                streetNumber: user.address.streetNumber,
                suburb : user.address.suburb
            }

            const prevAddress = user.previousAddress === undefined
                ? {}
                : {
                    postcode : user.previousAddress.postCode,
                    state : user.previousAddress.state,
                    streetName : user.previousAddress.street,
                    streetNumber : user.previousAddress.streetNumber,
                    suburb : user.previousAddress.suburb
                };
            
            const livingSituationData = {
                isLivingSituationStepCompleted: true,
                livingSituationData: {
                    currentAddress:  currentAddress,
                    prevAddress: prevAddress,
                    livingSituation: user.livingSituation
                }
            }            
            // Loan Requirements

            const deposit = parseInt(loan.deposit, 10) ?? 0;
            const vehiclePrice = parseInt(loan.amount, 10) ?? 0;

            const loanRequirement = {
                isLoanRequirementsStepCompleted: true,
                loanRequirementsData : {
                    assetCondition: extra.assetCondition,
                    baloonPayment: parseInt(loan.balloon, 10) ?? 0,
                    buildYear: parseInt(extra.vehicleYear, 10) ?? 0,
                    deposit: parseInt(loan.deposit, 10) ?? 0,
                    vehiclePrice: vehiclePrice + deposit,
                    loanAmount: parseInt(loan.amount, 10) ?? 0,
                    loanTerm: parseInt(loan.term, 10) ?? 0,
                    stockId: extra.vehicleNetworkId
                }
            }                       

            // Personal Details
            const fullName = `${user.firstName} ${user.middleName} ${user.lastName}`.replace(/\s+/g,' ');

            const personalDetails = {
                isPersonalDetailsStepCompleted : true,
                personalDetailsData:{
                    fullName: fullName,
                    dateOfBirth : getDataOfBirth(user.dateOfBirth), 
                    email : user.email,
                    firstName : user.firstName,
                    middleName : user.middleName,
                    lastName : user.lastName,
                    mobile : user.mobile,
                    residencyStatus : user.residency 
                }
            };            



            if (loanTypeDetails.loanType == "personal") {
                appDataCxt.setLoanMatchesData({ approvalId: loanApproval.id, uiCacheKey: uiCacheKey, ...loanTypeData, ...employmentData, ...livingSituationData, ...loanRequirement, ...personalDetails });
            }
            else {
                appDataCxt.setLoanMatchesData({ approvalId: loanApproval.id, uiCacheKey: uiCacheKey, ...loanTypeData, ...livingSituationData, ...loanRequirement, ...personalDetails });
            }

            
            
        }
     }, []);
    

     const getDataOfBirth = (val) => {
        const datePart = val.split("T");
        const dateParts = datePart[0].split("-");
        return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`; 
    }


    return (
        <div className="flex flex-col gap-6 pt-8">
            {tables.slice(0, numberOfItems).map(({id, table}) => (
                <TabularDataWidget key={id} data={table} />
            ))}
            {showButton() && (
                <LinkButtonPrimaryBorder 
                    className="inline-block cursor-pointer"
                    onClick={() => setNumberOfItems(tables.length)}
                >
                    {buttonText}
                </LinkButtonPrimaryBorder>
            )}
        </div>
    );
};

export default LoanMatchesLoader;
